import React, { FC } from 'react';
import styled from '@emotion/styled';
import {
    HeaderContainer,
    SkipToContentLink,
    MainHeader,
    MobileMenuWrapper,
    MaxWidthContainer
} from './Header.styles';
import LogoMenu from './section/LogoMenu';
import PrimaryNav from './section/PrimaryNav';
import ProfileMenu from './section/ProfileMenu';
import { Props } from './Header.types';
import navData from './data/nav.json';
import { css } from '@emotion/react';
import BottomMenu from './section/BottomMenu';

import authentication from './scripts/authentication';
import headerUI from './scripts/ui';
import myhome from './scripts/myhome';

const HeaderWrapper = styled('div')(css`
    position: relative;
    z-index: 998;
    font-size: medium;
    font-family: ZooplaSans, Helvetica, Arial, sans-serif, serif;
    font-variant: normal;
    font-weight: normal;
    letter-spacing: normal;
    text-align: left;
    visibility: visible;

    // reset Mason styles
    * {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
        position: static;
        -webkit-text-decoration: none;
        text-decoration: none;
        -webkit-transition: none;
        transition: none;
        font-size: inherit;
        font-variant: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        text-align: inherit;
        visibility: inherit;
        box-sizing: border-box;

        @media (prefers-reduced-motion) {
            animation: none !important;
            transition-property: none !important;
        }
    }
`);

const HeaderComponent: FC<Props> = (props) => {
    const encodedUrl = encodeURIComponent(props.path);
    const signInUrl = props.path.includes('/signin/')
        ? '/signin/?with_confirmation=true'
        : `/signin/?page_after_login=${encodedUrl}&return_url=${encodedUrl}&with_confirmation=true`;

    const authenticationScript = `(${authentication()})()`;
    const uiScript = `(${headerUI()})()`;
    const myhomeScript = `(${myhome()})()`;

    return (
        <HeaderWrapper id="main-header">
            <HeaderContainer
                data-testid="header"
                data-tracking-experiment-variation={props.experimentVariation}
                data-is-logged-in="null"
            >
                <MainHeader data-universal-header noShadow={props.noShadow}>
                    <SkipToContentLink href="#main-content">
                        Skip to main content
                    </SkipToContentLink>
                    <MaxWidthContainer data-universal-header-container>
                        <LogoMenu signInUrl={signInUrl} />
                        <MobileMenuWrapper data-testid="header-mobile-menu">
                            <ProfileMenu signInUrl={signInUrl} />
                            <PrimaryNav navItems={navData.navbar.items} />
                            <BottomMenu signInUrl={signInUrl} />
                        </MobileMenuWrapper>
                    </MaxWidthContainer>
                </MainHeader>
            </HeaderContainer>
            <script
                dangerouslySetInnerHTML={{
                    __html: uiScript
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: authenticationScript
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: myhomeScript
                }}
            />
        </HeaderWrapper>
    );
};

const Header = styled(HeaderComponent)();
export { Header };
